














































































































import {

  genPostReq
} from "@/services/checklist.service";



export default  {
  props: ['entryMachines', 'sel_addmachines', 'sel_machinesingroup', 'sel_removemachines'], 
  data() {
    return {
      filter1: null,
      machine_dialog: true,
      entry_machines: null, 
      curr_index: null, 
      lastSteps: -1,
      searchkey: "", 
      add_machines: null, 
      remove_machines: null, 
      showCreateNewGroup: false, 
      newGroupItems: [],
      newGroupName: null, 
      processing: false, 
    }
  },
  watch: {
    machine_dialog: function (val, oldVal) {
      if (!val) {
        this.$emit("dialogClosed", true);

        
      }
    },
    key_pressed: function (val, oldVal) {
      if (val) {
        this.lastSteps = -1
      }
    },
    searchkey: function (nval, oval) {
      this.$store.state.machine_filter = nval
    }
  },
  computed: {
    appLang: function() {
      return this.$store.state.lang
    },
    machine_groups() {
      return this.$store.state.cl_machine_groups
    },
    key_pressed() {
      return this.$store.state.key_shift
    },
    sel_machines() {
      if (this.add_machines) {
        return this.add_machines
      }
      return []; 
    },
    sel_remove_machines() {
      if (this.remove_machines) {
        return this.remove_machines
      }
      return []; 
    },
    machines() {
      if (this.searchkey && this.searchkey.length > 0) {
        return this.$store.state.machines.filter(machine => {
          return (
            machine.text.toLowerCase().indexOf(this.searchkey.toLowerCase()) !==
            -1
          );
        });
      }
      return this.$store.state.machines;
    },
  },
  mounted() {
    this.entry_machines = this.entryMachines
    this.searchkey = this.$store.state.machine_filter

    this.add_machines = (this.sel_addmachines) ? this.sel_addmachines : []
    this.remove_machines = (this.sel_removemachines) ? this.sel_removemachines : []
  },
  destroyed() {
    //console.log("destroyed")
  },
  methods: {
    saveNewGroup() {
      if (this.newGroupName && this.newGroupName.length > 2) {
        this.processing = true
        //console.log(this.newGroupName, this.newGroupItems)

        genPostReq('checklist', 'create-machine-group', { select_machine_group: this.$store.state.checklist.select_machine_group, machines: this.newGroupItems, name: this.newGroupName })
        .then(resp => {
            this.$store.state.cl_machine_groups = resp.data.list;
            this.$store.state.cl_machine_groups.unshift({ text: "-", value: "-1", machines: [] })
            this.$emit("changeMachines", {group_uid: resp.data.group_uid, add_machines: [], remove_machines: []});
            this.processing = false
        })

        // __ 
      }

    },
    createNewGroup: function() {
       
      this.newGroupItems = Array.from(new Set([...this.sel_machinesingroup, ...this.add_machines]));
      //resArr2 = Array.from(new Set([...machines, ...mg]));

      for (let n of this.remove_machines) {
        this.newGroupItems = this.newGroupItems.filter(function(item) {
          return item !== n
        })
      }

      this.showCreateNewGroup = true

    },
    resetFilter: function () {
      this.searchkey = ""
    },
    resetSelection: function () {
     // this.entry_machines = []
      this.add_machines.splice(0, this.add_machines.length)
      this.remove_machines.splice(0, this.remove_machines.length)
    },
    reverseSelection: function () {

      let new_entries = []

      for (let k of this.machines) {
        if ( !this.add_machines.find(element => element == k.value) && !this.sel_machinesingroup.find(element => element == k.value) ) {
          new_entries.push(k.value)
        }
      }

      this.add_machines = new_entries

    },
    closeMachineDialog: function () {
      this.machine_dialog = false
    },
    saveSelection: function () {
      this.$emit("changeMachines", {add_machines: this.add_machines, remove_machines: this.remove_machines});
    },
    activateSlot: function (item, force) {
      if ( this.sel_machinesingroup && this.sel_machinesingroup.indexOf(item.value) >= 0 ) {
        
        const idxR = this.remove_machines.indexOf(item.value) 

        if (idxR == -1) {
          if (force.add) {
             this.remove_machines.push(item.value)
          }
         
        }
        else {
          if (force.remove) {
           this.remove_machines.splice(idxR, 1)
          }
        }  

        return
      }

      const idx = this.add_machines.indexOf(item.value) 

      //console.log("$store.state.key_shift", this.$store.state.key_shift, item, index)
        if (idx == -1) {
          if (force.add) {
             this.add_machines.push(item.value)
          }
         
        }
        else {
          if (force.remove) {
           this.add_machines.splice(idx, 1)
          }
        }    
    },
    slotMachine: function (e, item, index) {
      e.preventDefault();

      let startIdx = 0; 
      let steps = 0; 

      if (this.key_pressed) {
        if (this.curr_index > index) {
           steps = this.curr_index-index
           startIdx = index
        }

        if (this.curr_index < index) {
          startIdx = this.curr_index
          steps = index-this.curr_index
        }
     
         if (steps > 0) {
          
          if (this.lastSteps > 0 && steps < this.lastSteps) {
            for (let index = this.lastSteps; index >  steps; index--) {
              this.activateSlot(this.machines[index+startIdx], {add: false, remove: true})
            }
          }
 
          this.lastSteps = steps
       
          for (let index = startIdx; index <= startIdx+steps; index++) {
             this.activateSlot(this.machines[index], {add: true, remove: false})
          }

         } 
         else {
           this.curr_index = index
           this.activateSlot(item, {add: true, remove: true})
         }
      }
      else {
        this.curr_index = index
        this.activateSlot(item, {add: true, remove: true})
      }

    },
   
  }
}

